module.exports = __webpack_public_path__ + "static/media/oleg_normal_left.70e9958d.png";